export default "__VITE_ASSET__BR0GfIVg__"